<script>
    import {
        EmailAndPwd,
        GoogleOauth,
        AppleOauth,
        Spinner,
    } from "@/components";
    import { trackEvent } from "@/services/firebase";
    import { getMobileOS } from "@/utils/common";
    import { translate } from "@/utils/format";
    import { onMount } from "svelte";

    let loading = $state(false);
    let platform = $state("web");

    onMount(() => {
        platform = getMobileOS();
        console.log("Platform detected:", platform);
        trackEvent("signin_page_loaded");
    });
</script>

<div class="signin">
    {#if loading}
        <Spinner text="" />
    {/if}
    <div class="signin__logo">
        <img src="/assets/img/logo.svg" alt="Logo" />
    </div>
    <p class="signin__txt">
        {translate("REGISTER_ACCOUNT_TEXT", "Registra tu cuenta")}<br />
        {translate(
            "KEEP_CONFIGURATION_TEXT",
            "para mantener tu configuración.",
        )}
    </p>
    <GoogleOauth onLoading={(val) => (loading = val)} />

    <div class="signin__or">{translate("OR", "o")}</div>
    <EmailAndPwd method="signin" onLoading={(val) => (loading = val)} />
    <p class="signin__account">
        {translate("HAVE_ACCOUNT", "¿Tienes una cuenta?")}
        <a href="/login">{translate("LOGIN", "Iniciar sesión")}</a>
    </p>
</div>
